import React from 'react';
import LeagueManagerSideBarleft from './LeagueManagerSideBarLeft';
import { useActiveLeague } from '../../App';

function LeagueManagerLayout({ children }) {
    const { activeLeague, setActiveLeague, activeSeason, setActiveSeason } = useActiveLeague();

    if (!activeLeague || !activeSeason) {
        return null;
    }

    return (
        <div className="container">
            <div className="row g-4">
                {/* Left sidebar (always visible) */}
                <div className="col-lg-3">
                    <LeagueManagerSideBarleft />
                </div>

                {/* Right-side content changes depending on route */}
                <div className="col-lg-9">
                    {React.cloneElement(children, { activeLeague, setActiveLeague, activeSeason, setActiveSeason })}
                </div>
            </div>
        </div>
    );
}

export default LeagueManagerLayout;